import React, { useEffect, useState } from 'react';
import '../styles/Navbar.css';

const NAV_LINKS = [
  { id: 'home', label: 'Home' },
  { id: 'about', label: 'About' },
  { id: 'services', label: 'Services' },
  { id: 'projects', label: 'Portfolio' },
];

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = isMenuOpen ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [isMenuOpen]);

  const scrollTo = (e, targetId) => {
    e.preventDefault();
    setIsMenuOpen(false);
    const element = document.getElementById(targetId);
    if (!element) return;
    const offset = 88;
    const top = element.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scrollTo({ top, behavior: 'smooth' });
  };

  return (
    <header className={`navbar${scrolled ? ' navbar--scrolled' : ''}`}>
      <div className="navbar-inner">
        <a href="#home" className="navbar-logo" onClick={(e) => scrollTo(e, 'home')}>
          <span className="navbar-logo-mark">MA</span>
        </a>

        <nav className={`navbar-links${isMenuOpen ? ' is-open' : ''}`} aria-label="Primary">
          {NAV_LINKS.map((link) => (
            <a key={link.id} href={`#${link.id}`} onClick={(e) => scrollTo(e, link.id)}>
              {link.label}
            </a>
          ))}
          <a
            href="#contact"
            className="navbar-cta navbar-cta--mobile"
            onClick={(e) => scrollTo(e, 'contact')}
          >
            Contact
          </a>
        </nav>

        <div className="navbar-actions">
          <a href="#contact" className="navbar-cta" onClick={(e) => scrollTo(e, 'contact')}>
            Contact
          </a>
        </div>

        <button
          type="button"
          className={`navbar-toggle${isMenuOpen ? ' is-open' : ''}`}
          onClick={() => setIsMenuOpen((v) => !v)}
          aria-label={isMenuOpen ? 'Close menu' : 'Open menu'}
          aria-expanded={isMenuOpen}
        >
          <span />
          <span />
        </button>
      </div>
    </header>
  );
};

export default Navbar;
